import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'User.RealtorSignUpScreen.title',
    defaultMessage: 'Create account'
  },
  text: {
    id: 'User.RealtorSignUpScreen.text',
    defaultMessage: 'Welcome to the Real Genius Platform'
  },
  benefits: {
    id: 'User.RealtorSignUpScreen.benefits',
    defaultMessage:
      'Are you Ready to Close More, Get to Yes quicker, Have visibility of your clients from 1st call to title company?'
  },
  name: {
    id: 'User.RealtorSignUpScreen.name',
    defaultMessage: 'Name'
  },
  email: {
    id: 'User.RealtorSignUpScreen.email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'User.RealtorSignUpScreen.password',
    defaultMessage: 'Password'
  },
  company: {
    id: 'User.RealtorSignUpScreen.company',
    defaultMessage: 'Company'
  },
  requiredName: {
    id: 'User.RealtorSignUpScreen.requiredName',
    defaultMessage: 'Name is required.'
  },
  requiredEmail: {
    id: 'User.RealtorSignUpScreen.requiredEmail',
    defaultMessage: 'Email is required.'
  },
  requiredPassword: {
    id: 'User.RealtorSignUpScreen.requiredPassword',
    defaultMessage: 'Password is required.'
  },
  requiredCompany: {
    id: 'User.RealtorSignUpScreen.requiredCompany',
    defaultMessage: 'Company is required.'
  },
  invalidEmail: {
    id: 'User.RealtorSignUpScreen.invalidEmail',
    defaultMessage: 'The email is invalid'
  },
  termsAndConditions1: {
    id: 'User.RealtorSignUpScreen.termsAndConditions1',
    defaultMessage: 'I agree to the '
  },
  termsAndConditions2: {
    id: 'User.RealtorSignUpScreen.termsAndConditions2',
    defaultMessage: 'Terms and Conditions'
  },
  lendersAndTitleCompaniesFeedback: {
    id: 'User.RealtorSignUpScreen.lendersAndTitleCompaniesFeedback',
    defaultMessage:
      'To get the full effect, please provide your favorite lender, title company partners, along with commonly used product links (MLS, Contracts, etc.) Limited to 3 each during the trial period.'
  },
  letUsKnowWhatYouNeed: {
    id: 'User.RealtorSignUpScreen.letUsKnowWhatYouNeed',
    defaultMessage: 'Let us know what you need'
  },
  accountCreated: {
    id: 'User.RealtorSignUpScreen.accountCreated',
    defaultMessage:
      'Your account has been created! Please check your email to verify your account. If you do not see the email, please check your spam folder.'
  },
  creatingAccount: {
    id: 'User.RealtorSignUpScreen.creatingAccount',
    defaultMessage: 'Creating your account...'
  },
  marketAreaZipcode: {
    id: 'User.RealtorSignUpScreen.marketAreaZipcode',
    defaultMessage: 'Market Area Zip Code'
  },
  requiredMarketAreaZipcode: {
    id: 'User.RealtorSignUpScreen.requiredMarketAreaZipcode',
    defaultMessage: 'Market Area Zip Code is required.'
  },
  invalidMarketAreaZipcode: {
    id: 'User.RealtorSignUpScreen.invalidMarketAreaZipcode',
    defaultMessage:
      'The Market Area Zip Code is invalid. It should be a 5-digit number or a 5+4 digit number (e.g., 12345 or 12345-6789).'
  }
});
